// Material Kit 2 PRO React pages
import SignUpCover from "../../pages/createaccount";

export default function SingUpCoverPage() {
  return <SignUpCover />;
}
